<!-- Simülasyon Motor Ayarları Dialog -->
<div class="sim-motor-dialog" *ngIf="sim">

    <!-- Simülasyon Motor Seçimi -->
    <div *ngIf="sim.kutukMeshSecili"
         style="margin-bottom:6px;padding:6px;background:rgba(30,30,50,0.6);border-radius:4px;border:1px solid rgba(0,255,255,0.2);">
        <div style="font-size:9px;color:#0ff;margin-bottom:4px;font-weight:600;">SİMÜLASYON MOTORU:</div>
        <div style="display:flex;gap:3px;flex-wrap:wrap;">
            <button class="ui mini button" style="padding:4px 8px;font-size:8px;flex:1;min-width:60px;"
                [style.background]="sim.kutukSimModu === 'dexel' ? '#2185d0' : 'rgba(255,255,255,0.06)'"
                [style.color]="sim.kutukSimModu === 'dexel' ? 'white' : '#aaa'"
                (click)="kutukMotorDegistir('dexel')">
                <i class="layer group icon" style="font-size:9px;"></i> Triple-Dexel
                <div style="font-size:6px;margin-top:1px;" [style.color]="sim.kutukSimModu === 'dexel' ? '#ccc' : '#aaa'">2.5D | Hızlı</div>
            </button>
            <button class="ui mini button" style="padding:4px 8px;font-size:8px;flex:1;min-width:60px;"
                [style.background]="sim.kutukSimModu === 'voxel' ? '#21ba45' : 'rgba(255,255,255,0.06)'"
                [style.color]="sim.kutukSimModu === 'voxel' ? 'white' : '#aaa'"
                (click)="kutukMotorDegistir('voxel')">
                <i class="cube icon" style="font-size:9px;"></i> Voxel CSG
                <div style="font-size:6px;margin-top:1px;" [style.color]="sim.kutukSimModu === 'voxel' ? '#ccc' : '#aaa'">3D | Gerçek</div>
            </button>
            <button class="ui mini button" style="padding:4px 8px;font-size:8px;flex:1;min-width:60px;"
                [style.background]="sim.kutukSimModu === 'marchingcubes' ? '#a333c8' : 'rgba(255,255,255,0.06)'"
                [style.color]="sim.kutukSimModu === 'marchingcubes' ? 'white' : '#aaa'"
                (click)="kutukMotorDegistir('marchingcubes')">
                <i class="gem icon" style="font-size:9px;"></i> GPU MC
                <div style="font-size:6px;margin-top:1px;" [style.color]="sim.kutukSimModu === 'marchingcubes' ? '#ccc' : '#aaa'">3D | 0 Readback</div>
            </button>
            <button class="ui mini button" style="padding:4px 8px;font-size:8px;flex:1;min-width:60px;"
                [style.background]="sim.kutukSimModu === 'sdf' ? '#00b5ad' : 'rgba(255,255,255,0.06)'"
                [style.color]="sim.kutukSimModu === 'sdf' ? 'white' : '#aaa'"
                (click)="kutukMotorDegistir('sdf')">
                <i class="circle icon" style="font-size:9px;"></i> SDF
                <div style="font-size:6px;margin-top:1px;" [style.color]="sim.kutukSimModu === 'sdf' ? '#ccc' : '#aaa'">3D | Pürüzsüz</div>
            </button>
            <button class="ui mini button" style="padding:4px 8px;font-size:8px;flex:1;min-width:60px;"
                [style.background]="sim.kutukSimModu === 'zbuffer' ? '#e03997' : 'rgba(255,255,255,0.06)'"
                [style.color]="sim.kutukSimModu === 'zbuffer' ? 'white' : '#aaa'"
                (click)="kutukMotorDegistir('zbuffer')">
                <i class="image icon" style="font-size:9px;"></i> Z-Buffer
                <div style="font-size:6px;margin-top:1px;" [style.color]="sim.kutukSimModu === 'zbuffer' ? '#ccc' : '#aaa'">6-Dir | Endüstri</div>
            </button>
            <button class="ui mini button" style="padding:4px 8px;font-size:8px;flex:1;min-width:60px;"
                [style.background]="sim.kutukSimModu === 'visual' ? '#f2711c' : 'rgba(255,255,255,0.06)'"
                [style.color]="sim.kutukSimModu === 'visual' ? 'white' : '#aaa'"
                (click)="kutukMotorDegistir('visual')">
                <i class="eye icon" style="font-size:9px;"></i> Görsel
                <div style="font-size:6px;margin-top:1px;" [style.color]="sim.kutukSimModu === 'visual' ? '#ccc' : '#aaa'">Sadece yol</div>
            </button>
        </div>
        <div style="font-size:7px;color:#888;margin-top:3px;text-align:center;">
            <span *ngIf="sim.kutukSimModu === 'dexel'">Performans odaklı | XY grid + Z depth spans</span>
            <span *ngIf="sim.kutukSimModu === 'voxel'">Gerçekçi 3D | Octree + GPU compute</span>
            <span *ngIf="sim.kutukSimModu === 'marchingcubes'">GPU Marching Cubes | Sıfır CPU readback</span>
            <span *ngIf="sim.kutukSimModu === 'sdf'">Signed Distance Field | Pürüzsüz yüzey</span>
            <span *ngIf="sim.kutukSimModu === 'zbuffer'">6-Yönlü Derinlik | Endüstri standardı</span>
            <span *ngIf="sim.kutukSimModu === 'visual'">Sadece takım yolu gösterimi</span>
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!--                        MOTOR AYARLARI                          -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div *ngIf="sim.kutukMeshSecili"
         style="margin-bottom:6px;padding:6px 8px;background:rgba(16,20,28,0.8);border:1px solid rgba(0,255,255,0.2);border-radius:4px;">
        <div style="font-size:9px;color:#0ff;margin-bottom:4px;font-weight:600;">MOTOR AYARLARI</div>

        <!-- GENEL AYARLAR -->
        <details open style="margin-bottom:3px;">
            <summary style="cursor:pointer;color:#fa0;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> GENEL
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Padding (mm):</span>
                    <input type="range" [min]="0" [max]="50" [step]="1" [(ngModel)]="sim.simPadding"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.simPadding}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">3D Çözünürlük:</span>
                    <input type="range" [min]="0" [max]="10" [step]="0.5" [(ngModel)]="sim.simResolution3D"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:28px;text-align:right;">{{sim.simResolution3D === 0 ? 'Oto' : sim.simResolution3D + '/mm'}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">2D Çözünürlük:</span>
                    <input type="range" [min]="0" [max]="5" [step]="0.25" [(ngModel)]="sim.simResolution2D"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:28px;text-align:right;">{{sim.simResolution2D === 0 ? 'Oto' : sim.simResolution2D + '/mm'}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Max Voxel (3D):</span>
                    <input type="range" [min]="1000000" [max]="100000000" [step]="1000000" [(ngModel)]="sim.simMaxVoxels3D"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:28px;text-align:right;">{{(sim.simMaxVoxels3D / 1000000).toFixed(0)}}M</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Max Cell (2D):</span>
                    <input type="range" [min]="100000" [max]="2000000" [step]="50000" [(ngModel)]="sim.simMaxCells2D"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:28px;text-align:right;">{{(sim.simMaxCells2D / 1000).toFixed(0)}}K</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">GPU Mesh Aralığı:</span>
                    <input type="range" [min]="50" [max]="1000" [step]="50" [(ngModel)]="sim.simGPUMeshInterval"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:30px;text-align:right;">{{sim.simGPUMeshInterval}}ms</span>
                </div>
            </div>
        </details>

        <!-- DEXEL AYARLARI -->
        <details *ngIf="sim.kutukSimModu === 'dexel'" style="margin-bottom:3px;">
            <summary style="cursor:pointer;color:#2185d0;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> DEXEL
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Batch Size:</span>
                    <input type="range" [min]="1" [max]="50" [step]="1" [(ngModel)]="sim.dexelBatchSize"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.dexelBatchSize}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Smoothing:</span>
                    <input type="range" [min]="0" [max]="10" [step]="1" [(ngModel)]="sim.dexelSmoothing"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.dexelSmoothing}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Smooth Sigma:</span>
                    <input type="range" [min]="0" [max]="5" [step]="0.1" [(ngModel)]="sim.dexelSmoothSigma"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.dexelSmoothSigma === 0 ? 'Oto' : sim.dexelSmoothSigma}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Snapshot Aralığı:</span>
                    <input type="range" [min]="5" [max]="100" [step]="5" [(ngModel)]="sim.snapshotAraligi"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.snapshotAraligi}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Max Snapshot:</span>
                    <input type="range" [min]="10" [max]="200" [step]="10" [(ngModel)]="sim.maxSnapshotSayisi"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.maxSnapshotSayisi}}</span>
                </div>
            </div>
        </details>

        <!-- VOXEL / GPU MC AYARLARI -->
        <details *ngIf="sim.kutukSimModu === 'voxel' || sim.kutukSimModu === 'marchingcubes'" style="margin-bottom:3px;">
            <summary style="cursor:pointer;color:#21ba45;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> VOXEL / GPU MC
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">Batch Size:</span>
                    <input type="range" [min]="10" [max]="200" [step]="10" [(ngModel)]="sim.voxelBatchSize"
                        style="width:70px;height:2px;">
                    <span style="color:#0ff;width:20px;text-align:right;">{{sim.voxelBatchSize}}</span>
                </div>
            </div>
        </details>

        <!-- SDF AYARLARI -->
        <details *ngIf="sim.kutukSimModu === 'sdf'" style="margin-bottom:3px;">
            <summary style="cursor:pointer;color:#00b5ad;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> SDF
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">GPU Aktif:</span>
                    <span style="color:#0ff;">{{sim.useGPUSDF ? 'Evet' : 'Hayır'}}</span>
                </div>
            </div>
        </details>

        <!-- Z-BUFFER AYARLARI -->
        <details *ngIf="sim.kutukSimModu === 'zbuffer'" style="margin-bottom:3px;">
            <summary style="cursor:pointer;color:#e03997;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> Z-BUFFER
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:4px;margin-bottom:3px;">
                    <span style="flex:1;color:#aaa;">GPU Aktif:</span>
                    <span style="color:#0ff;">{{sim.useGPUZBuffer ? 'Evet' : 'Hayır'}}</span>
                </div>
            </div>
        </details>

        <!-- UYGULA BUTONU -->
        <button *ngIf="sim.kutukSimAktif"
            class="ui mini button" style="width:100%;margin-top:4px;padding:4px 8px;font-size:8px;background:#2185d0;color:white;border:none;border-radius:3px;"
            (click)="motorAyarlariUygula()">
            <i class="redo icon" style="font-size:8px;margin-right:3px;"></i>Uygula (Motoru Yeniden Başlat)
        </button>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!--                       CNC KESİM MODU                           -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div *ngIf="sim.kutukSimAktif" style="margin-bottom:6px;padding:4px;background:rgba(0,100,100,0.3);border-radius:4px;">
        <div style="font-size:8px;color:#0ff;margin-bottom:2px;">CNC Kesim Modu:</div>
        <div style="display:flex;gap:4px;">
            <button class="ui mini button" style="padding:4px 10px;font-size:9px;flex:1;"
                [style.background]="sim.silindirYonModu === 0 ? '#21ba45' : ''"
                (click)="silindirYonModuDegisti(0)"
                title="CNC Freze: Takım ÜSTTEN gelir, tool tip'ten stock TOP'a kadar keser">
                <i class="arrow down icon" style="margin-right:4px;"></i>Freze (Üstten)
            </button>
            <button class="ui mini button" style="padding:4px 10px;font-size:9px;flex:1;"
                [style.background]="sim.silindirYonModu === 1 ? '#2185d0' : ''"
                (click)="silindirYonModuDegisti(1)"
                title="CNC Torna: Takım ALTTAN gelir, tool tip'ten stock BOTTOM'a kadar keser">
                <i class="arrow up icon" style="margin-right:4px;"></i>Torna (Alttan)
            </button>
        </div>
        <!-- Ters Yön Toggle -->
        <div style="display:flex;align-items:center;gap:4px;margin-top:4px;padding-top:4px;border-top:1px solid rgba(0,255,255,0.2);">
            <span style="font-size:8px;color:#fa0;flex:1;">Takım Yönü Ters:</span>
            <button class="ui mini button" style="padding:3px 12px;font-size:9px;"
                [style.background]="sim.dexelTersYon ? '#f2711c' : '#555'"
                (click)="tiklandiTersYonToggle()"
                title="Takım kesim yönünü tersine çevir - bazı kalıplar için gerekli olabilir">
                <i [class]="sim.dexelTersYon ? 'redo icon' : 'undo icon'" style="margin-right:4px;"></i>
                {{sim.dexelTersYon ? 'AÇIK' : 'Kapalı'}}
            </button>
        </div>
        <div style="font-size:7px;color:#888;margin-top:2px;">
            Aktif: {{sim.silindirYonModu === 0 ? 'Freze - Tool tip → Stock TOP' : 'Torna - Tool tip → Stock BOTTOM'}}
            {{sim.dexelTersYon ? ' | Ters Yön' : ''}}
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!--                       SARMA AYARLARI                            -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div *ngIf="sim.kutukSimAktif && sim.kutukSimModu === 'dexel'"
         style="margin-bottom:6px;padding:6px;background:linear-gradient(135deg, rgba(40,25,10,0.6), rgba(50,35,20,0.6));border:1px solid rgba(255,170,0,0.3);border-radius:4px;">
        <div style="color:#fa0;margin-bottom:4px;font-weight:600;font-size:9px;letter-spacing:0.5px;">SARMA AYARLARI</div>

        <div style="display:flex;align-items:center;gap:4px;margin-bottom:4px;">
            <label style="font-size:8px;flex:1;">Geri sarmada doldur:</label>
            <button class="ui mini button" style="padding:2px 8px;font-size:8px;"
                [style.background]="sim.geriSarmaDoldur ? '#21ba45' : '#555'"
                (click)="sim.geriSarmaDoldur=!sim.geriSarmaDoldur;CD.detectChanges();">
                {{sim.geriSarmaDoldur ? 'Evet' : 'Hayır'}}
            </button>
        </div>

        <div style="display:flex;align-items:center;gap:4px;margin-bottom:4px;">
            <label style="font-size:8px;flex:1;">Snapshot aralığı:</label>
            <input type="number" class="fikoinput" style="width:50px;font-size:8px;padding:2px;"
                [ngModel]="sim.snapshotAraligi" (ngModelChange)="sim.snapshotAraligi=$event;CD.detectChanges();"
                [min]="10" [max]="1000" [step]="10">
            <span style="font-size:7px;color:#888;">poz</span>
        </div>

        <div style="display:flex;align-items:center;gap:4px;margin-bottom:4px;">
            <label style="font-size:8px;flex:1;">Max snapshot:</label>
            <input type="number" class="fikoinput" style="width:50px;font-size:8px;padding:2px;"
                [ngModel]="sim.maxSnapshotSayisi" (ngModelChange)="sim.maxSnapshotSayisi=$event;CD.detectChanges();"
                [min]="5" [max]="100" [step]="5">
            <span style="font-size:7px;color:#888;">adet</span>
        </div>

        <div style="display:flex;align-items:center;gap:4px;font-size:7px;color:#aaa;margin-top:4px;border-top:1px solid rgba(255,255,255,0.15);padding-top:4px;">
            <span style="flex:1;">{{sim.snapshotSayisi}}/{{sim.maxSnapshotSayisi}} | Son: {{sim.sonSnapshotPoz >= 0 ? sim.sonSnapshotPoz : '-'}}</span>
            <button class="ui mini icon button" style="padding:2px 4px;font-size:7px;"
                title="Tüm snapshot'ları temizle"
                (click)="snapshotlariTemizle()">
                <i class="trash icon" style="font-size:8px;"></i>
            </button>
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!--                        STOK AYARLARI                            -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div *ngIf="sim.kutukSimAktif && sim.kutukSimModu === 'dexel'"
         style="margin-bottom:6px;padding:6px 8px;background:rgba(16,20,28,0.8);border:1px solid rgba(0,255,255,0.2);border-radius:4px;">
        <div style="font-size:9px;color:#0ff;margin-bottom:4px;font-weight:600;">STOK AYARLARI</div>

        <!-- Kalite Presetleri -->
        <div style="display:flex;gap:2px;margin-bottom:5px;">
            <button *ngFor="let q of [['performance','Hızlı','#f2711c'],['balanced','Dengeli','#2185d0'],['quality','Kalite','#21ba45']]"
                class="ui mini button" style="padding:2px 0;font-size:7px;flex:1;margin:0;border:none;"
                [style.background]="sim.kalitePreseti === q[0] ? q[2] : 'rgba(255,255,255,0.06)'"
                (click)="tiklandiKalitePreseti(q[0])">{{q[1]}}</button>
        </div>

        <!-- Malzeme -->
        <details open style="margin-bottom:3px;">
            <summary style="cursor:pointer;color:#fa0;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> MALZEME
                <span style="flex:1;"></span>
                <input type="color" [ngModel]="sim.kutukStokRenk" (ngModelChange)="stokRenkDegisti($event)"
                       style="width:16px;height:12px;border:1px solid #555;border-radius:2px;padding:0;cursor:pointer;background:none;"
                       (click)="$event.stopPropagation();">
                <button class="ui mini button" style="padding:1px 4px;font-size:7px;margin:0;border:none;"
                    [style.background]="sim.kutukRenklendirmeModu === 'depth' ? '#2185d0' : sim.kutukRenklendirmeModu === 'tool' ? '#21ba45' : '#444'"
                    (click)="$event.stopPropagation();tiklandiRenklendirmeModuDegistir()">
                    {{sim.kutukRenklendirmeModu === 'depth' ? 'Derinlik' : 'Takım'}}
                </button>
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;gap:2px;margin-bottom:3px;">
                    <button *ngFor="let p of ['aluminum','steel','brass','titanium']"
                        class="ui mini button" style="padding:2px 5px;margin:0;font-size:7px;border:none;"
                        [style.background]="sim.malzemePreset === p ? '#2185d0' : 'rgba(255,255,255,0.06)'"
                        (click)="tiklandiMalzemePreset(p)">
                        {{p === 'aluminum' ? 'Alm' : p === 'steel' ? 'Çlk' : p === 'brass' ? 'Prn' : 'Ttn'}}
                    </button>
                    <span *ngFor="let c of ['#B8C0C8','#8B4513','#C8A86E','#2C2C2C']"
                          style="width:10px;height:10px;border-radius:2px;cursor:pointer;border:1px solid #444;flex-shrink:0;"
                          [style.background]="c" (click)="stokRenkDegisti(c)"></span>
                </div>
                <!-- PBR -->
                <div *ngFor="let s of [
                    {key:'manuelRoughness', label:'Rgh', color:'#c90', preset:'roughness', def:0.35},
                    {key:'manuelMetalness', label:'Mtl', color:'#8af', preset:'metalness', def:0.12},
                    {key:'manuelClearcoat', label:'Cct', color:'#6df', preset:'clearcoat', def:0.4},
                    {key:'manuelEnvMapIntensity', label:'Env', color:'#af6', preset:'envMapIntensity', def:0.25}
                ]" style="display:flex;align-items:center;gap:2px;height:14px;">
                    <span style="min-width:22px;" [style.color]="s.color">{{s.label}}</span>
                    <input type="range" [min]="0" [max]="100" [step]="2"
                        [ngModel]="sim[s.key] < 0 ? (sim.MALZEME_PRESETLERI[sim.malzemePreset]?.[s.preset] || s.def) * 100 : sim[s.key]"
                        (ngModelChange)="sim[s.key]=$event;manuelPBRDegisti();CD.detectChanges();"
                        style="flex:1;height:2px;margin:0;">
                    <span style="min-width:22px;text-align:right;font-size:7px;" [style.color]="s.color">
                        {{sim[s.key] < 0 ? '~' : sim[s.key]}}
                    </span>
                </div>
            </div>
        </details>

        <!-- Yüzey -->
        <details open style="margin-bottom:3px;border-top:1px solid rgba(255,255,255,0.06);padding-top:3px;">
            <summary style="cursor:pointer;color:#0af;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9660;</span> YÜZEY
                <span style="flex:1;"></span>
                <span style="font-size:7px;color:#666;">AO:{{sim.aoYogunluk}} Sm:{{sim.dexelSmoothing}}</span>
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:2px;height:14px;">
                    <span style="min-width:22px;color:#fa0;">AO</span>
                    <input type="range" [min]="0" [max]="100" [step]="5"
                        [ngModel]="sim.aoYogunluk" (ngModelChange)="sim.aoYogunluk=$event;aoYogunlukDegisti();CD.detectChanges();"
                        style="flex:1;height:2px;margin:0;">
                    <span style="min-width:22px;text-align:right;color:#fa0;font-size:7px;">{{sim.aoYogunluk}}</span>
                    <input type="range" [min]="1" [max]="8" [step]="1" title="AO Radius"
                        [ngModel]="sim.aoRadius" (ngModelChange)="sim.aoRadius=$event;aoRadiusDegisti();CD.detectChanges();"
                        style="width:32px;height:2px;margin:0;">
                    <span style="min-width:10px;text-align:right;color:#f80;font-size:7px;">{{sim.aoRadius}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:2px;height:14px;">
                    <span style="min-width:22px;color:#fa0;">Sm</span>
                    <input type="range" [min]="0" [max]="5" [step]="1"
                        [ngModel]="sim.dexelSmoothing" (ngModelChange)="sim.dexelSmoothing=$event;dexelSmoothingDegisti();CD.detectChanges();"
                        style="flex:1;height:2px;margin:0;">
                    <span style="min-width:22px;text-align:right;color:#fa0;font-size:7px;">{{sim.dexelSmoothing || '-'}}</span>
                    <input *ngIf="sim.dexelSmoothing > 0" type="range" [min]="0" [max]="100" [step]="5" title="Sigma"
                        [ngModel]="sim.dexelSmoothSigma * 100" (ngModelChange)="sim.dexelSmoothSigma=$event/100;dexelSmoothingDegisti();CD.detectChanges();"
                        style="width:32px;height:2px;margin:0;">
                    <span *ngIf="sim.dexelSmoothing > 0" style="min-width:10px;text-align:right;color:#fa0;font-size:7px;">{{sim.dexelSmoothSigma === 0 ? '~' : sim.dexelSmoothSigma.toFixed(1)}}</span>
                </div>
                <div style="display:flex;align-items:center;gap:2px;height:14px;">
                    <span style="min-width:22px;color:#ff0;">Exp</span>
                    <input type="range" [min]="30" [max]="200" [step]="5"
                        [ngModel]="sim.toneMappingExposure" (ngModelChange)="sim.toneMappingExposure=$event;toneMappingExposureDegisti();CD.detectChanges();"
                        style="flex:1;height:2px;margin:0;">
                    <span style="min-width:22px;text-align:right;color:#ff0;font-size:7px;">{{(sim.toneMappingExposure/100).toFixed(1)}}</span>
                </div>
                <!-- Togglelar -->
                <div style="display:flex;align-items:center;gap:4px;margin-top:2px;">
                    <span style="cursor:pointer;padding:1px 5px;border-radius:3px;font-size:7px;"
                        [style.background]="sim.kenarCizgileriAktif ? '#2185d0' : 'rgba(255,255,255,0.06)'"
                        (click)="tiklandiKenarCizgileriToggle()">Kenar</span>
                    <span style="cursor:pointer;padding:1px 5px;border-radius:3px;font-size:7px;"
                        [style.background]="sim.icDuvarAktif ? '#21ba45' : 'rgba(255,255,255,0.06)'"
                        (click)="tiklandiIcDuvarToggle()">Duvar</span>
                    <span *ngIf="sim.kenarCizgileriAktif" style="flex:1;display:flex;align-items:center;gap:2px;">
                        <input type="range" [min]="5" [max]="100" [step]="5" title="Kenar opaklık"
                            [ngModel]="sim.kenarCizgisiOpaklik" (ngModelChange)="sim.kenarCizgisiOpaklik=$event;kenarOpaklikDegisti();CD.detectChanges();"
                            style="flex:1;height:2px;margin:0;">
                        <input type="range" [min]="10" [max]="100" [step]="5" title="Kenar eşik"
                            [ngModel]="sim.kenarCizgisiEsik" (ngModelChange)="sim.kenarCizgisiEsik=$event;kenarEsikDegisti();CD.detectChanges();"
                            style="width:28px;height:2px;margin:0;">
                    </span>
                </div>
            </div>
        </details>

        <!-- Performans -->
        <details style="margin-bottom:2px;border-top:1px solid rgba(255,255,255,0.06);padding-top:3px;">
            <summary style="cursor:pointer;color:#0f8;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9654;</span> PERF
                <span style="flex:1;"></span>
                <span style="font-size:7px;" [style.color]="sim.gpuAktif ? '#0f0' : sim.workerAktif ? '#0ff' : '#fa0'">
                    {{sim.gpuAktif ? 'GPU' : sim.workerAktif ? 'Worker' : 'CPU'}}
                </span>
                <span style="font-size:7px;color:#666;">{{sim.snapshotSayisi}}/{{sim.maxSnapshotSayisi}}</span>
            </summary>
            <div style="padding:3px 0 0 0;">
                <div style="display:flex;align-items:center;gap:3px;height:16px;">
                    <span style="min-width:28px;color:#0a8;">Snap</span>
                    <input type="number" class="fikoinput" style="width:44px;font-size:7px;padding:1px 2px;"
                        [ngModel]="sim.snapshotAraligi" (ngModelChange)="sim.snapshotAraligi=$event;CD.detectChanges();"
                        [min]="10" [max]="1000" [step]="10">
                    <span style="min-width:22px;color:#0a8;">Max</span>
                    <input type="number" class="fikoinput" style="width:36px;font-size:7px;padding:1px 2px;"
                        [ngModel]="sim.maxSnapshotSayisi" (ngModelChange)="sim.maxSnapshotSayisi=$event;CD.detectChanges();"
                        [min]="5" [max]="100" [step]="5">
                </div>
                <div style="display:flex;align-items:center;gap:3px;height:16px;">
                    <span style="min-width:28px;color:#0a8;">Mesh</span>
                    <input type="range" [min]="1" [max]="10" [step]="1"
                        [ngModel]="sim.meshGuncellemeAraligi" (ngModelChange)="sim.meshGuncellemeAraligi=$event;CD.detectChanges();"
                        style="flex:1;height:2px;margin:0;">
                    <span style="min-width:16px;text-align:right;color:#0a8;font-size:7px;">{{sim.meshGuncellemeAraligi}}x</span>
                    <span style="cursor:pointer;padding:1px 5px;border-radius:3px;font-size:7px;"
                        [style.background]="sim.geriSarmaDoldur ? '#21ba45' : 'rgba(255,255,255,0.06)'"
                        (click)="sim.geriSarmaDoldur=!sim.geriSarmaDoldur;CD.detectChanges();">Doldur</span>
                </div>
            </div>
        </details>

        <!-- Takımlar -->
        <details *ngIf="sim.takimListesi?.length > 0" style="border-top:1px solid rgba(255,255,255,0.06);padding-top:3px;">
            <summary style="cursor:pointer;color:#9c0;font-size:8px;font-weight:600;letter-spacing:0.3px;user-select:none;outline:none;list-style:none;display:flex;align-items:center;gap:3px;">
                <span style="font-size:6px;opacity:0.5;">&#9654;</span> TAKIMLAR
                <span style="font-size:7px;color:#666;">{{sim.takimListesi.length}}</span>
            </summary>
            <div style="max-height:70px;overflow-y:auto;padding-top:2px;">
                <div *ngFor="let t of sim.takimListesi" style="display:flex;align-items:center;gap:3px;height:13px;">
                    <span style="width:8px;height:8px;border-radius:2px;flex-shrink:0;" [style.background]="t.renk"></span>
                    <span style="font-size:7px;color:#aaa;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{t.isim}}</span>
                </div>
            </div>
        </details>
    </div>


</div>
